import { PureComponent, ReactNode } from 'react';
import { Input, Table } from 'antd';
import Fuse from 'fuse.js';
const { Column } = Table;
import { DeleteOutlined } from '@ant-design/icons';
import { GRefer } from '../../../../../store/db';
import { EditableCellV2 } from './MedTableRenderer';
import AddDoctorDialog from '../AddDoctorDialog';
import { GReferWithTrack } from '../../../leftPanel/DoctorReferralSearchInput';
import { SpecialityEntity } from '../../../../../api/fetchSpecialityForDoctor';
import { AntTooltip } from '../../../../common/AntTooltip';
import { CreateReferalData, DocEntity } from '../../../../../api/createReferal';

type Props = {
    referData?: CreateReferalData;
    deleteReferral: (index: number) => void;
    onSaveNotes: (index: number, notes: string) => void;
    specialities: SpecialityEntity[] | null | undefined;
    onSelect: (option: GReferWithTrack, isAddDoctorDialog?: number) => void;
    mobileOptional?: boolean;
};

type State = {
    elements?: GRefer[];
    isAddDoctorDialog?: GReferWithTrack;
    addDoctorIndex?: number;
};

const fuseConfig = { keys: ['name'], threshold: 0.2 };

class DoctorReferralTable extends PureComponent<Props, State> {
    state: State = {
        elements: undefined,
    };

    fuse = new Fuse([] as GRefer[], fuseConfig);

    onCloseDoctorDialog = () => {
        this.setState({ isAddDoctorDialog: undefined, addDoctorIndex: undefined });
    };

    openDoctorDialog = (index: number): void => {
        const { referData } = this.props;
        if (!referData?.doc?.[index]?.phone?.value || !referData?.doc?.[index]?.clinic?.landmark) {
            this.setState({
                addDoctorIndex: index,
                isAddDoctorDialog: {
                    ...(referData || {}),
                    id: `${referData?.id || ''}`,
                    s_id: `${referData?.id || ''}`,
                    s_name: referData?.name || referData?.s_name || '',
                    name: referData?.name || '',
                    doc: {
                        name: {
                            f: referData?.doc?.[index]?.name?.f || '',
                            l: referData?.doc?.[index]?.name?.l || '',
                        },
                        phone: {
                            code: referData?.doc?.[index]?.phone?.code || '',
                            value: referData?.doc?.[index]?.phone?.value || '',
                        },
                        clinic: referData?.doc?.[index]?.clinic,
                    },
                },
            });
        }
    };

    render(): ReactNode {
        const { deleteReferral, onSaveNotes, specialities, mobileOptional } = this.props;
        const { isAddDoctorDialog, addDoctorIndex } = this.state;
        const refers = this.props.referData ? this.props.referData.doc : [];

        if (refers.length <= 0) {
            return null;
        }

        return (
            <div className="relative">
                <Table
                    key={'referdatatable-' + refers.length}
                    className="mt-8"
                    bordered={true}
                    showHeader={false}
                    dataSource={refers}
                    pagination={false}
                    rowKey={(_, index) => `refer-${index}`}
                    id="refer"
                >
                    <Column
                        key="doc"
                        className="w-50p"
                        render={(refer: DocEntity, __, index) => {
                            const clinicAdress = [
                                refer?.clinic?.name,
                                refer?.clinic?.landmark,
                                refer?.clinic?.city,
                                refer?.clinic?.state,
                                refer?.clinic?.pincode,
                            ]
                                .filter(Boolean)
                                .join(', ');

                            return {
                                children: (
                                    <div className="py-8">
                                        <div className="flex items-center space-x-16">
                                            <div className="font-700 text-neutral-black text-14 placeholder-neutral-6">
                                                {[refer?.name?.f, refer?.name?.l]
                                                    .filter(Boolean)
                                                    .join(' ')
                                                    .trim() || refer?.s_name}
                                            </div>
                                            <AntTooltip content="Doctor is on Eka network">
                                                <p className="cursor-pointer">
                                                    {/* {refer?.referred_doctor_oid && (
                                                        <svg
                                                            className="w-16 h-16"
                                                            viewBox="0 0 105 117"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M104.436 33.768C104.144 38.8643 102.1 43.6607 98.4497 47.408L63.4061 83.3816C62.53 84.2809 61.5079 85.1803 60.3398 85.9297C52.3089 91.4757 41.3578 90.4264 34.4951 83.3816C30.2607 79.0348 28.0704 72.8893 28.6545 66.5939C28.8005 62.8467 31.8668 59.9988 35.5172 59.9988C39.3136 59.9988 42.3799 63.1464 42.3799 67.0436C42.3799 69.142 41.5038 70.9407 40.1897 72.2897C40.6277 73.4889 41.3578 74.688 42.3799 75.5873C44.1321 77.386 46.6143 78.4352 49.0966 78.4352C50.7028 78.4352 52.1629 78.1354 53.4771 77.386C54.3531 76.9363 55.0832 76.3368 55.8133 75.5873L73.0431 57.9003L65.8883 50.5557L55.6673 40.0634C53.9151 38.2647 51.4328 37.2155 48.9506 37.2155C46.4683 37.2155 43.9861 38.2647 42.2339 40.0634C41.0658 41.2625 40.1897 42.7614 39.7516 44.2603C41.3578 45.6093 42.5259 47.5579 42.5259 49.8062C42.5259 53.7034 39.4596 56.8511 35.6632 56.8511C32.1589 56.8511 29.0925 54.0032 28.8005 50.4058C27.6324 43.6607 29.6766 36.9157 34.4951 31.9693C38.2915 28.0722 43.402 25.8238 48.9506 25.8238C54.3531 25.8238 59.6097 28.0722 63.4061 31.9693L73.6271 42.4616L80.7819 49.8062L90.7109 39.6137C92.6091 37.6651 93.4852 35.2669 93.4852 32.5689C93.4852 30.1706 92.6091 27.9223 91.0029 26.2735C86.7685 21.477 81.658 17.7298 75.9634 15.0318C69.9768 12.3337 63.6981 10.8348 57.1274 10.8348C44.8622 10.8348 33.473 15.7812 24.7121 24.6247C16.0972 33.4682 11.2787 45.3095 11.2787 57.9003C11.2787 70.4911 16.0972 82.1825 24.7121 91.1759C33.327 100.019 44.8622 104.966 57.1274 104.966C63.6981 104.966 69.9768 103.617 75.9634 100.769C81.658 98.0708 86.7685 94.3236 91.0029 89.5271C94.3613 85.6299 94.2152 79.7842 90.7109 76.037L83.4101 68.5425L91.1489 60.5983L98.4497 68.0928C106.188 76.037 106.481 88.6277 99.1798 97.0216C93.9232 103.017 87.6446 107.664 80.6359 110.961C73.3351 114.409 65.4503 116.058 57.2734 116.058C49.6807 116.058 42.2339 114.559 35.2252 111.561C28.5085 108.563 22.3758 104.366 17.2653 99.12C12.0088 93.724 7.92036 87.5785 5.14608 80.6836C2.22578 73.4889 0.765625 65.8445 0.765625 58.0502C0.765625 50.2559 2.22578 42.6115 5.14608 35.4168C8.06638 28.5219 12.1548 22.2265 17.2653 16.9803C22.5219 11.5843 28.5085 7.38737 35.2252 4.53946C42.2339 1.54166 49.6807 0.042762 57.2734 0.042762C65.4503 0.042762 73.1891 1.84143 80.6359 5.13901C87.7906 8.43659 93.9232 13.0832 99.1798 19.0788C101.37 21.6269 103.122 24.7746 103.852 28.0722C104.29 29.4212 104.436 31.6695 104.436 33.768Z"
                                                                fill="#7265E3"
                                                            ></path>
                                                        </svg>
                                                    )} */}
                                                </p>
                                            </AntTooltip>

                                            {refer?.clinic?.gplacesid && (
                                                <a href={refer?.clinic?.gplacesid} target="_blank">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 384 512"
                                                        className="w-14 h-14 fill-darwin-primary-500 cursor-pointer"
                                                    >
                                                        <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
                                                    </svg>
                                                </a>
                                            )}
                                        </div>
                                        <div className="mt-4 uppercase text-10 text-darwin-neutral-600">
                                            {[
                                                refer?.name && refer?.s_name,
                                                refer?.phone?.value
                                                    ? `${
                                                          refer?.phone?.code
                                                              ? `${refer?.phone?.code} `
                                                              : ''
                                                      }${refer?.phone?.value}`
                                                    : undefined,
                                                clinicAdress,
                                            ]
                                                .filter(Boolean)
                                                .join(' | ')}
                                        </div>
                                        {!mobileOptional &&
                                            (!refer?.phone?.value || !refer?.clinic?.landmark) && (
                                                <div
                                                    className="mt-4 cursor-pointer uppercase text-10 text-darwin-primary-500 font-700"
                                                    onClick={() => this.openDoctorDialog(index)}
                                                >
                                                    + Add mobile number / address
                                                </div>
                                            )}
                                    </div>
                                ),
                            };
                        }}
                    />
                    <Column
                        key="notes"
                        className="w-50p"
                        render={(refer, __, index) => {
                            return (
                                <div className="flex space-x-8 items-center">
                                    <EditableCellV2
                                        fieldName={`refer-notes-${index}`}
                                        defaultValue={refer?.note || ''}
                                        label="Notes for the doctor"
                                        onBlur={(e) => {
                                            onSaveNotes(index, e.target.value);
                                        }}
                                    >
                                        <Input.TextArea
                                            autoFocus
                                            defaultValue={refer?.note || ''}
                                            rows={2}
                                            placeholder="Notes for the doctor"
                                        />
                                    </EditableCellV2>
                                    <DeleteOutlined
                                        style={{ color: '#616A8F' }}
                                        size={24}
                                        onClick={() => deleteReferral(index)}
                                        onPointerLeaveCapture={undefined}
                                    />
                                </div>
                            );
                        }}
                        ellipsis={true}
                    />
                </Table>
                {isAddDoctorDialog && (
                    <div className="w-full absolute z-50 bg-white shadow-800 border border-darwin-neutral-200">
                        <AddDoctorDialog
                            doctorData={isAddDoctorDialog}
                            onCloseDoctorDialog={this.onCloseDoctorDialog}
                            specialities={specialities}
                            onSave={(t) => this.props.onSelect(t, addDoctorIndex)}
                            disabledName={this.props?.referData?.referred_doctor_oid ? true : false}
                            disabledClinic={
                                this.props?.referData?.referred_doctor_oid ? true : false
                            }
                            disabledSpeciality={
                                this.props?.referData?.referred_doctor_oid ? true : false
                            }
                        />
                    </div>
                )}
                {/* {!mobileOptional && !this.props?.referData?.doc?.[0]?.phone?.value && (
                    <div className="bg-darwin-status-warning-100 flex items-center p-8">
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                            >
                                <path
                                    d="M8 14.5C5.84375 14.5 3.875 13.375 2.79688 11.5C1.71875 9.64844 1.71875 7.375 2.79688 5.5C3.875 3.64844 5.84375 2.5 8 2.5C10.1328 2.5 12.1016 3.64844 13.1797 5.5C14.2578 7.375 14.2578 9.64844 13.1797 11.5C12.1016 13.375 10.1328 14.5 8 14.5ZM8 5.5C7.67188 5.5 7.4375 5.75781 7.4375 6.0625V8.6875C7.4375 9.01562 7.67188 9.25 8 9.25C8.30469 9.25 8.5625 9.01562 8.5625 8.6875V6.0625C8.5625 5.75781 8.30469 5.5 8 5.5ZM7.25 10.75C7.25 11.1719 7.57812 11.5 8 11.5C8.39844 11.5 8.75 11.1719 8.75 10.75C8.75 10.3516 8.39844 10 8 10C7.57812 10 7.25 10.3516 7.25 10.75Z"
                                    fill="#D73A2F"
                                />
                            </svg>
                        </div>
                        <span className="pl-8 text-13">
                            Add mobile number to patient share details with the doctor on Whatsapp.
                        </span>
                        <span
                            className="pl-16 text-13 font-700 text-darwin-primary-500 cursor-pointer"
                            onClick={this.openDoctorDialog}
                        >
                            + Add mobile number
                        </span>
                    </div>
                )} */}
            </div>
        );
    }
}

export default DoctorReferralTable;
